var exports = {
  "Ze": "AddFriendView.module__friendRequestContainer___eFoxQU",
  "Nr": "AddFriendView.module__card___eFoxQU",
  "Og": "AddFriendView.module__heroIcon___eFoxQU",
  "DD": "AddFriendView.module__title___eFoxQU",
  "VA": "AddFriendView.module__subtitle___eFoxQU",
  "KJ": "AddFriendView.module__formContainer___eFoxQU",
};

module.exports = exports;
